import { render } from "./CreateUserLayoutPage.vue?vue&type=template&id=0e994d16&ts=true"
import script from "./CreateUserLayoutPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserLayoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__